import { render, staticRenderFns } from "./ConnectWalletBase.vue?vue&type=template&id=5990f00c&"
import script from "./ConnectWalletBase.vue?vue&type=script&lang=js&"
export * from "./ConnectWalletBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports